var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-spin',{staticClass:"w-100",attrs:{"spinning":_vm.spinning}},[_c('Detail',{attrs:{"list":_vm.list}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }